import { render, staticRenderFns } from "./envRelateScene.vue?vue&type=template&id=08a48a69"
import script from "./envRelateScene.vue?vue&type=script&lang=js"
export * from "./envRelateScene.vue?vue&type=script&lang=js"
import style0 from "./envRelateScene.vue?vue&type=style&index=0&id=08a48a69&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports